const tooltips = {
  naptar: 'Eseményeket lehet berögzíteni különböző naptártípusokhoz ezen a felületen.',
  naptartipus: 'Helyszínenként különböző naptárak vehetők fel. Ez a naptár viselkedését szabályozza.',
  esemenytipus: 'Meghatározza az összetartozó, rögzíthető események típusát az adott naptárban.',
  kezdete: 'Esemény időtartam rögzítéskor az eseménytípus választás után alapértelmezett értéke lesz a mezőnek.',
  vege: 'Esemény időtartam rögzítéskor az eseménytípus választás után alapértelmezett értéke lesz a mezőnek. Csak a kezdete mezővel együtt tölthető.',
  idotartam: 'Az időtartam megadásával is meghatározható a vége időpont. Az időtartam és vége egyszerre nem adható meg.',
  szinvalasztas: 'Az eseménytípushoz tartozó események ugyanazzal a színnel vannak jelölve.',
  masolas: 'A forrás nap másolásra kerül az összes kiválasztott cél napra. Ütközés esetén az adott napra nem kerül másolt esemény beszúrásra.',
  ismvege: 'A megadott napra még beszúrásra kerül az esemény.',
  utolsonap: 'Pipa esetén minden hónap utolsó napjára lesz érvényes, egyébként minden hónap adott napján.',
};

export default function getTooltip(name) {
  return tooltips[name];
}
